/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leaderboard_Pr_Type_TimeInputs */

const fr_leaderboard_pr_type_time = /** @type {(inputs: Leaderboard_Pr_Type_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps`)
};

/**

* @param {Leaderboard_Pr_Type_TimeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const leaderboard_pr_type_time = /** @type {((inputs?: Leaderboard_Pr_Type_TimeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leaderboard_Pr_Type_TimeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_leaderboard_pr_type_time(inputs)
});